import * as angular from 'angular';
import * as _ from 'lodash';
import {States} from "../../shared/config/constant.module";
import template from './checkLists.tpl.html';
import CheckListOverrideModule, {
  CheckList, CheckListCommon
} from "../../models/checkLists/checkListOverride.module";
import {apsEnums} from "../../shared/dto/aps.enums";
import {Plant} from "../../models/navigation";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsCommon} from "../../shared/dto/aps.common";
import UIUtilityServiceName, {EnumOption, UIUtilityService} from "../../services/utility/uiUtility.service";
import AuthDataServiceName, {AuthDataService} from "../../services/auth/authData.service";
import CheckListsServiceName, {CheckListsService} from "../../services/checkLists/checkLists.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import LocationsServiceName, {LocationsService} from "../../services/locations/locations.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import NewGuidServiceName, {NewGuidService} from "../../services/utility/newguid.service";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import EditCheckList, {openEditCheckList} from "./checkList.controller";
import {apsCommands} from "../../shared/dto/aps.commands";
import CopyCheckList, {openCopyCheckList} from "./copyCheckList.controller";
import JobRunServiceName, { JobRunService } from '../../services/jobs/jobRun.service';
import DefectTypeServiceName, { DefectTypeService } from '../../services/defects/defectType.service';

let requires = [UIUtilityServiceName, AuthDataServiceName, CheckListsServiceName, LoaderServiceName,
  LocationsServiceName, NotifyServiceName, NewGuidServiceName, NavigationServiceName, EditCheckList,
  CopyCheckList, JobRunServiceName, DefectTypeServiceName];

export interface CheckListsController {
  checkLists: CheckList[];
  levels: EnumOption[];
  level: apsEnums.CheckListLevel;
  plants: Plant[];
  plant: Plant;
  shops: apsViewModels.ShopNavigation[];
  shop: apsViewModels.ShopNavigation;
  wareClasses: apsCommon.IdAndName[];
  wareClass: apsCommon.IdAndName;
  allShops: apsViewModels.ShopNavigation[];
  jobs: apsViewModels.JobItem[];
  job: apsViewModels.JobItem;
  jobName: string;

  department: string;
  departments: string[];
  pasType: string;
  pasTypes: string[];
  topNumber: string;
  name: string;
  orderBy: string;

  addCheckList(): void;
  openCheckList(checkList: apsViewModels.CheckListSummary): void;
  deleteCheckList(checkList: apsViewModels.CheckListSummary): void;

  levelChanged(): void;
  plantChanged(): void;
  shopChanged(): void;
  jobNameChanged(): void;
  clearJob(): void;

  toggleOverride(checkList: CheckList): void;
}

export class CheckListsCtrl implements CheckListsController {
  shopsAllSelection: apsViewModels.ShopNavigation;
  plantsAllSelection: Plant;
  wareClassAllSelection: apsCommon.IdAndName;
  checkLists: CheckList[];
  levels: EnumOption[];
  level: apsEnums.CheckListLevel;
  plants: Plant[];
  plant: Plant;
  shops: apsViewModels.ShopNavigation[];
  shop: apsViewModels.ShopNavigation;
  wareClasses: apsCommon.IdAndName[];
  wareClass: apsCommon.IdAndName;
  allShops: apsViewModels.ShopNavigation[];
  jobs: apsViewModels.JobItem[];
  job: apsViewModels.JobItem;
  jobName: string;

  department: string;
  departments: string[];
  pasType: string;
  pasTypes: string[];
  topNumber: string;
  name: string;
  orderBy: string;

  private locations: apsCommon.IdAndName[];

  private authDataService: AuthDataService;
  private loaderService: LoaderService;
  private notifyService: NotifyService;
  private checkListsService: CheckListsService;
  private newGuidService: NewGuidService;
  private $modal: mm.foundation.modal;
  private uiUtilityService: UIUtilityService;

  constructor($modal: mm.foundation.modal,
              checkListsService: CheckListsService,
              jobRunService: JobRunService,
              loaderService: LoaderService,
              locationsService: LocationsService,
              notifyService: NotifyService,
              uiUtilityService: UIUtilityService,
              newGuidService: NewGuidService,
              navigationService: NavigationService,
              defectTypeService: DefectTypeService,
              $q: angular.IQService,
              authDataService: AuthDataService) {
    this.$modal = $modal;
    this.uiUtilityService = uiUtilityService;
    this.checkListsService = checkListsService;
    this.newGuidService = newGuidService;
    this.level = apsEnums.CheckListLevel.All;
    this.plantsAllSelection = CheckListCommon.getAllPlantsItem();
    this.shopsAllSelection = CheckListCommon.getAllShopsItem();
    this.wareClassAllSelection = CheckListCommon.getAllWareClassItem();
    this.plant = this.plantsAllSelection;
    this.shop = this.shopsAllSelection;
    this.wareClass = this.wareClassAllSelection;
    this.orderBy = 'name';
    this.levels = uiUtilityService.getListOptionsFromEnum(apsEnums.CheckListLevel, apsEnums.CheckListLevel.All);
    this.plants = [];
    this.shops = [];
    this.wareClasses = [];

    this.loaderService = loaderService;
    this.authDataService = authDataService;
    this.notifyService = notifyService;

    var locationsPromise = locationsService.initialize().then(() => {
      return navigationService.getPlants(true).then((plants: Plant[]) => {
        this.plants = plants;
        this.shops = [this.shopsAllSelection];
        this.allShops = <apsViewModels.ShopNavigation[]>_.flatten(_.map(plants, 'shops'));
        this.locations = locationsService.getOtherLocations();

        this.plants.unshift(this.plantsAllSelection);

        if (this.shops.length === 1) {
          this.shop = this.shops[0];
        }

        return this.loadCheckLists();
      });
    }, notifyService.handleApiErrors);

    var jobsPromise = jobRunService.getJobs()
      .then(jobs => this.jobs = jobs.filter(x => !x.isDeleted), notifyService.handleApiErrors);

    var wareClassPromise = defectTypeService.getDefectTypeWareClasses()
      .then(wareClasses => this.wareClasses = [this.wareClassAllSelection].concat(wareClasses) );

    loaderService.loadingPromise($q.all([locationsPromise, jobsPromise, wareClassPromise]));
  }

  levelChanged() {
    switch (this.level) {
      case apsEnums.CheckListLevel.Corporate:
        this.plant = this.plantsAllSelection;
        this.plantChanged();
        break;
      case apsEnums.CheckListLevel.Plant:
        this.shop = this.shopsAllSelection;
        this.shopChanged();
        break;
       default:
        this.refresh();
        break;
    }
  }

  plantChanged() {
    this.shops = this.plantShops();
    this.shop = _.first(this.shops);
    this.shopChanged();
  }

  shopChanged() {
    this.refresh();
  }

  jobNameChanged() {
    this.job = _.find(this.jobs, { name: this.jobName });
    this.refresh();
  }

  clearJob() {
    if (!this.job) {
      return;
    }
    this.job = null;
    this.jobName = null;
    this.refresh();
  }

  refresh() {
    this.loaderService.loadingPromise(this.loadCheckLists()
      .then(null, this.notifyService.handleApiErrors));
  }

  private updateClassificationLists() {
    this.departments = _.uniq(_.filter(_.map(this.checkLists, 'department'), x => !!x));
    this.pasTypes = _.uniq(_.filter(_.map(this.checkLists, 'pasType'), x => !!x));
  }

  private loadCheckLists(): angular.IPromise<any> {
    return this.checkListsService
      .getCheckLists(this.plant.id, this.shop.id, this.level)
      .then((checkLists: apsViewModels.CheckListSummary[]) => {
          this.checkLists = CheckListOverrideModule.extendCheckLists(
            checkLists,
            this.plants, this.allShops, this.locations, this.wareClasses,
            this.plant.id,
            this.shop.id,
            this.job ? this.job.id : null,
            this.authDataService
          );
          this.updateClassificationLists();
        });
  }

  private plantShops() {
    var shops = this.plant.shops;
    if (shops.length === 0 || shops[0] !== this.shopsAllSelection) {
      shops.unshift(this.shopsAllSelection);
    }
    return shops;
  }

  checkLists_filtered() {
    var result = _(this.checkLists);
    if (this.wareClass.id !== null) {
      result = result.filter(x => x.wareClassId == this.wareClass.id);
    }
    if (this.department) {
      result = result.filter(x => x.department === this.department);
    }
    if (this.pasType) {
      result = result.filter(x => x.pasType === this.pasType);
    }
    if (this.topNumber) {
      result = result.filter(x => x.topNumber && x.topNumber.indexOf(this.topNumber) >= 0);
    }
    if (this.name) {
      var name = this.name.toLowerCase();
      result = result.filter(x => x.name.toLowerCase().indexOf(name) >= 0);
    }
    return result.value();
  }

  private getNonGroupCheckLists(plant, shop) {
    var plantId = plant ? plant.id : null;
    var shopId = shop ? shop.id : null;
    return _.filter(this.checkLists, {isGroup: false, isDisabled: false, plantId: plantId, shopId: shopId});
  }

  canAddCheckList() {
    if (this.plant) {
      return this.authDataService.isPlantAdmin(this.plant.id);
    } else {
      return this.authDataService.isAdmin();
    }
  }

  addCheckList() {
    var plants = this.plants.concat();
    var shops = [];
    if (this.plant.id) {
      plants = [this.plant];
      shops = [this.shopsAllSelection].concat(this.plant.shops);
      if (this.shop.id) {
        shops = [this.shop];
      }
    }

    openEditCheckList({
      id: null,
      mode: 'add',
      plants: plants,
      shops: shops,
      jobs: this.jobs,
      job: this.job,
      plant: this.plant,
      shop: this.shop,
      wareClasses: this.wareClasses,
      wareClass: this.wareClass,
      checkLists: _.filter(this.getNonGroupCheckLists(this.plant, this.shop), c => c.checkListGroupId === null),
      locations: this.locations,
      departments: this.departments,
      pasTypes: this.pasTypes,
      onAdd: (data: apsCommands.AddCheckList) => {
        if (!data) {
          return;
        }

        let checkList: apsViewModels.CheckListSummary = {
          id: data.id,
          name: data.name,
          department: data.department,
          pasType: data.pasType,
          topNumber: data.topNumber,
          plantId: data.plantId,
          shopId: data.shopId,
          wareClassId: data.wareClassId,
          locationType: data.locationType,
          locationId: data.locationId,
          isGroup: data.isGroup,
          checkListGroupId: null,
          overrides: [],
          isDeleted: false,
          createdOn: new Date(),
          deletedOn: null
        };

        let jobId = this.job ? this.job.id : null;
        let item = CheckListOverrideModule.extendCheckList(checkList, this.checkLists, this.plants,
          this.allShops, this.locations, this.wareClasses,
          this.plant.id, this.shop.id, jobId, this.authDataService);
        this.checkLists.push(item);
        this.updateClassificationLists();

        this.applyGroupToChildLists(data);
      },
      checkListGroupName: null
    }, this.$modal);
  }

  openCheckList(checkList: CheckList) {
    var plants = this.plants.concat();
    var shops = [];
    var plant = this.plant;
    var shop = this.shop;
    if (checkList.plantId) {
      plant = _.find(plants, {id: checkList.plantId});
      plants = [plant];
      shops = [this.shopsAllSelection].concat(plant.shops);
      if (checkList.shopId) {
        shop = _.find(shops, {id: checkList.shopId});
        shops = [shop];
      }
    }

    var wareClass = this.wareClassAllSelection;
    if (checkList.wareClassId) {
      wareClass = _.find(this.wareClasses, {id: checkList.wareClassId});
    }

    var checkLists = _.filter(this.getNonGroupCheckLists(plant, shop),
      c => c !== checkList && c.checkListGroupId === null);
    checkLists = checkLists.concat(_.filter(this.checkLists,
      c => c.checkListGroupId === checkList.id));
    let result = openEditCheckList({
      id: checkList.id,
      mode: checkList.canEdit ? 'edit' : 'view',
      plants: plants,
      shops: shops,
      plant: plant,
      shop: shop,
      wareClasses: this.wareClasses,
      wareClass: wareClass,
      jobs: this.jobs,
      job: this.job,
      checkLists: checkLists,
      checkListGroupName: checkList.checkListGroupName,
      locations: this.locations,
      departments: this.departments,
      pasTypes: this.pasTypes
    }, this.$modal);

    result.then((response: {action: string, data: any}) => {
      if (!response) {
        return;
      }

      if (response.action === 'override') {
        var data = <apsCommands.SaveCheckListOverride>response.data;
        var checkList = _.find(this.checkLists, { id: data.checkListId });
        var override = _.find(checkList.overrides, {plantId: data.plantId, shopId: data.shopId, jobId: data.jobId});
        if (override) {
          override.roleId = data.roleId;
        } else {
          checkList.overrides.push({
            id: null,
            checkListId: data.checkListId,
            plantId: data.plantId,
            shopId: data.shopId,
            jobId: data.jobId,
            roleId: data.roleId,
            isMandatory: data.isMandatory,
            isDisabled: data.isDisabled
          });
        }
        return;
      }

      var cmd = <apsCommands.SaveCheckList>response.data;
      var checkList = _.find(this.checkLists, { id: cmd.id });
      checkList.name = cmd.name;
      checkList.department = cmd.department;
      checkList.pasType = cmd.pasType;
      checkList.topNumber = cmd.topNumber;
      checkList.locationId = cmd.locationId;
      checkList.locationType = cmd.locationType;
      checkList.locationName = CheckListOverrideModule.getLocationName(checkList, this.locations);
      checkList.wareClassId = cmd.wareClassId;
      checkList.wareClass = CheckListOverrideModule.getWareClassName(checkList, this.wareClasses);
      this.applyGroupToChildLists(cmd);
      this.updateClassificationLists();
    });
  }

  private applyGroupToChildLists(data: apsCommands.CheckListBase) {
    if (data.isGroup) {
      _.forEach(_.filter(this.checkLists, {checkListGroupId: data.id}), (c: CheckList) => {
        c.checkListGroupId = null;
        c.checkListGroupName = null;
        CheckListOverrideModule.setOverrideValue(c,
          this.plant ? this.plant.id : null, this.shop ? this.shop.id : null,
          this.job ? this.job.id : null, this.authDataService);
      });
      _.forEach(data.childCheckLists, (child: apsCommands.SaveChildCheckList) => {
        var childList = _.find(this.checkLists, {id: child.id});
        if (childList) {
          childList.checkListGroupId = data.id;
          childList.checkListGroupName = data.name;
          CheckListOverrideModule.setOverrideValue(childList,
            this.plant ? this.plant.id : null, this.shop ? this.shop.id : null, 
            this.job ? this.job.id : null, this.authDataService);
        }
      });
    }
  }

  copyCheckList(checkList: CheckList) {
    var result = openCopyCheckList({
      originalCheckList: checkList,
      plants: this.plants
    }, this.$modal);

    result.then((data) => {
      if (!data) {
        return;
      }

      var checkList = _.assign<apsViewModels.CheckListSummary>({}, data);
      var item = CheckListOverrideModule.extendCheckList(checkList, this.checkLists,
        this.plants, this.allShops, this.locations, this.wareClasses, this.plant.id, this.shop.id,
        this.job ? this.job.id : null, this.authDataService);
      this.checkLists.push(item);
    });
  }

  deleteCheckList(checkList: CheckList) {
    this.uiUtilityService.confirm('Delete checklist?').then((result) => {
      if (result) {
        this.loaderService.loadingPromise(
          this.checkListsService.deleteCheckList(checkList.id).then(() => {
            _.remove(this.checkLists, checkList);
          }, this.notifyService.handleApiErrors));
      }
    });
  }

  private saveOverride(cmd: apsCommands.SaveCheckListOverride,
                       checkList: CheckList) {
    var idx = _.findIndex(<any[]>checkList.overrides, {plantId: cmd.plantId, shopId: cmd.shopId, jobId: cmd.jobId});
    var successAction = () => {
      if (checkList.overrides === null) {
        checkList.overrides = [];
      }

      if (idx >= 0) {
        var override = checkList.overrides[idx];
        override.isMandatory = cmd.isMandatory;
        override.isDisabled = cmd.isDisabled;
        override.roleId = cmd.roleId;
      } else {
        checkList.overrides.push({
          id: null,
          checkListId: checkList.id,
          plantId: cmd.plantId,
          shopId: cmd.shopId,
          jobId: cmd.jobId,
          roleId: cmd.roleId,
          isMandatory: cmd.isMandatory,
          isDisabled: cmd.isDisabled
        });
      }
      CheckListOverrideModule.setOverrideValue(checkList, cmd.plantId, cmd.shopId, cmd.jobId, this.authDataService);
    };

    this.loaderService.loadingPromise(
      this.checkListsService.saveOverride(cmd).then(successAction, this.notifyService.handleApiErrors)
    );
  }

  toggleOverride(checkList: CheckList) {
    var plantId = checkList.plantId || this.plant.id;
    var shopId = checkList.shopId || this.shop.id;
    var jobId = this.job ? this.job.id : null;
    var override = _.find(checkList.overrides, {plantId: plantId, shopId: shopId, jobId: jobId});
    var cmd = {
      checkListId: checkList.id,
      plantId: plantId,
      shopId: shopId,
      jobId: jobId,
      roleId: override ? override.roleId : null,
      isMandatory: checkList.isMandatory || false,
      isDisabled: checkList.isMandatory ? false : checkList.isDisabled
    };
    checkList.isDisabled = cmd.isDisabled;

    this.saveOverride(cmd, checkList);
  }
}

export default angular.module('aps.controller.checkLists', requires)
  .config(($stateProvider) => {
    $stateProvider.state({
      name: States.CHECKLISTS,
      url: '/admin/checkLists',
      controller: 'CheckListsCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Check Lists',
        authorizePlantAdmin: true,
        v2Uri: 'aps/settings/check-lists'
      }
    });
  })
  .controller('CheckListsCtrl', CheckListsCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/checkLists/checkLists.controller.ts